import { useSelector } from 'react-redux';
import { useAppSelector } from '../reducers';
import { isAppAuthSelector } from '../selectors/AuthSelectors';
import { getIsLatestVersionOfCrmSuiteInProductInventoryPreSeatsAndSeatsOnlySelector, getIsLatestVersionOfProductInProductInventorySelector } from '../selectors/ProductInventorySelectors';
import { getTBSuiteProductForProductLevelSelector } from '../selectors/ProductsSelectors';
import { useGlobalLoading } from './loadingHooks';
import { useRecommendedProduct } from './useRecommendations';
export const useShowProductV2ModelRecommendedBadge = ({
  productLevel,
  productLine
}) => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const {
    recommendationResponse
  } = useRecommendedProduct();
  const recommendedTier = recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.tier;
  const recommendedHub = recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub;
  const isAppReady = useGlobalLoading();
  const isCurrentPlanLevel = useSelector(state => {
    if (!isAppReady) {
      return false;
    }
    const suiteProduct = getTBSuiteProductForProductLevelSelector(state, {
      suiteProductLevel: productLevel
    });
    if (suiteProduct) {
      return getIsLatestVersionOfProductInProductInventorySelector(state, {
        productIdentifier: {
          apiName: suiteProduct === null || suiteProduct === void 0 ? void 0 : suiteProduct.apiName
        }
      });
    }
    return getIsLatestVersionOfCrmSuiteInProductInventoryPreSeatsAndSeatsOnlySelector(state, productLevel);
  });
  const showProductV2ModelRecommendedBadge = !isCurrentPlanLevel && isAppAuth && recommendedHub === productLine && recommendedTier === productLevel;
  return showProductV2ModelRecommendedBadge;
};